module.exports = __webpack_public_path__ + "static/media/Hanwha_340W_bbb.a9f96c7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hanwha_340W_bbb.jpg
// module id = 1063
// module chunks = 0